import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PoSearchFilterMode, PoTableColumn } from '@po-ui/ng-components';

import { ChangesetTableRow } from './changeset-table.model';

@Component({
  selector: 'app-changeset-table',
  templateUrl: './changeset-table.component.html',
  styleUrls: ['./changeset-table.component.css']
})
export class ChangesetTableComponent {
  @Input() iconClass!: string;
  @Input() label!: string;
  @Input() items: ChangesetTableRow[] = [];
  @Input() columns: PoTableColumn[] = [];
  @Input() showMore = false;
  @Input() hasMoreHistory = false;
  @Input() loadingMoreHistory = false;

  @Output() selected = new EventEmitter<ChangesetTableRow>();
  @Output() unselected = new EventEmitter<ChangesetTableRow>();
  @Output() showMoreClick = new EventEmitter<void>();

  /**
   * Modo do campo de busca do `po-table`, exposto ao template.
   *
   * A busca roda só sobre o que já foi CARREGADO — o histórico de changesets pagina por
   * "mostrar mais", e digitar um termo não busca páginas que ainda não vieram. Com
   * dezenas de changesets carregados, ainda assim acha mais rápido que rolar a tabela. O
   * padrão da lib é `startsWith`, que não acha uma palavra no MEIO da descrição — por
   * isso força `contains`.
   */
  readonly filterType = PoSearchFilterMode.contains;

  /**
   * Altura fixa só quando há linha demais pra caber sem rolagem — mesma regra das
   * tabelas de PR, commit e revisão do modal (`tableHeightFor` em
   * `send-review-modal.component.ts`).
   *
   * Fixar sempre um valor, como este componente fazia, deixava uma tabela de dois
   * changesets com uma faixa de espaço vazio embaixo; sem altura nenhuma, uma tabela de
   * cinquenta rola a página inteira em vez de rolar só a tabela.
   */
  get tableHeight(): number | undefined {
    return this.items.length > 6 ? 320 : undefined;
  }
}
